import {biErrorCodes} from './BIErrors'

export class BIActionTracker {
  constructor(reporter) {
    this.trackedActions = {}
    this.reporter = reporter
  }

  config = (params) => {
    this.trackedActions = params
  }

  actionHandler = (action, state, lastBITarget) => {
    try {
      const handlers = this.trackedActions[action.type]
      if (handlers) {
        handlers.forEach(handler => {
          const eventToReport = handler(action, state, lastBITarget)
          if (eventToReport) {
            this.reporter.reportEvent(eventToReport)
          }
        })
      }
    } catch (error) {
      this.reporter.logError(new Error('Error while handling action in biActionTracker'),
        {errorCode: biErrorCodes.actionHandlerError, error, action})
    }
  }
}
